<template>
  <div class="admin-layout">
    <Navbar />
    <v-main class="grey lighten-4" v-bind:class="isDashboard">
      <router-view></router-view>
    </v-main>
  </div>
</template>
<script>
import Navbar from '../components/Navbar'

export default {
  name: 'AdminLayout',
  components: {
    Navbar,
  },
  computed: {
    isDashboard: function() {
        return this.$route.name == 'dashboard-attendance' || this.$route.name == 'live-tracking' ? '' : 'mx-4 mt-4';
    }
  }
}
</script>